/* tslint:disable */
/* eslint-disable */
/**
 * Search v2
 * Search v2
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../../../runtime';
import type { ExportRequest, ExportResponse } from '../models';

export interface ExportSearchRequest {
	xINFASEARCHLANGUAGE: ExportSearchXINFASEARCHLANGUAGE;
	exportRequest: ExportRequest;
	xINFAORGID?: string;
	xINFATID?: string;
	xINFATRACEEVENT?: string;
	xINFATGID?: string;
	fileName?: string;
}

/**
 *
 */
export class ExportApi extends runtime.BaseAPI {
	/**
	 */
	async exportSearchRaw(
		requestParameters: ExportSearchRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction,
	): Promise<runtime.ApiResponse<ExportResponse>> {
		if (requestParameters.xINFASEARCHLANGUAGE === null || requestParameters.xINFASEARCHLANGUAGE === undefined) {
			throw new runtime.RequiredError(
				'xINFASEARCHLANGUAGE',
				'Required parameter requestParameters.xINFASEARCHLANGUAGE was null or undefined when calling exportSearch.',
			);
		}

		if (requestParameters.exportRequest === null || requestParameters.exportRequest === undefined) {
			throw new runtime.RequiredError('exportRequest', 'Required parameter requestParameters.exportRequest was null or undefined when calling exportSearch.');
		}

		const queryParameters: any = {};

		if (requestParameters.fileName !== undefined) {
			queryParameters['fileName'] = requestParameters.fileName;
		}

		const headerParameters: runtime.HTTPHeaders = {};

		headerParameters['Content-Type'] = 'application/json';

		if (requestParameters.xINFAORGID !== undefined && requestParameters.xINFAORGID !== null) {
			headerParameters['X-INFA-ORG-ID'] = String(requestParameters.xINFAORGID);
		}

		if (requestParameters.xINFASEARCHLANGUAGE !== undefined && requestParameters.xINFASEARCHLANGUAGE !== null) {
			headerParameters['X-INFA-SEARCH-LANGUAGE'] = String(requestParameters.xINFASEARCHLANGUAGE);
		}

		if (requestParameters.xINFATID !== undefined && requestParameters.xINFATID !== null) {
			headerParameters['X-INFA-TID'] = String(requestParameters.xINFATID);
		}

		if (requestParameters.xINFATRACEEVENT !== undefined && requestParameters.xINFATRACEEVENT !== null) {
			headerParameters['X-INFA-TRACEEVENT'] = String(requestParameters.xINFATRACEEVENT);
		}

		if (requestParameters.xINFATGID !== undefined && requestParameters.xINFATGID !== null) {
			headerParameters['X-INFA-TG-ID'] = String(requestParameters.xINFATGID);
		}

		if (this.configuration && this.configuration.apiKey) {
			headerParameters['IDS-USER-TOKEN'] = this.configuration.apiKey('IDS-USER-TOKEN'); // userToken authentication
		}

		if (this.configuration && this.configuration.apiKey) {
			headerParameters['IDS-AGENT-SESSION-ID'] = this.configuration.apiKey('IDS-AGENT-SESSION-ID'); // agentSessionId authentication
		}

		if (this.configuration && this.configuration.apiKey) {
			headerParameters['IDS-SERVICE-TOKEN'] = this.configuration.apiKey('IDS-SERVICE-TOKEN'); // serviceToken authentication
		}

		if (this.configuration && this.configuration.accessToken) {
			const token = this.configuration.accessToken;
			const tokenString = await token('bearerAuth', []);

			if (tokenString) {
				headerParameters['Authorization'] = `Bearer ${tokenString}`;
			}
		}
		const response = await this.request(
			{
				path: `/api/v1/export`,
				method: 'POST',
				headers: headerParameters,
				query: queryParameters,
				body: requestParameters.exportRequest,
			},
			initOverrides,
		);

		return new runtime.JSONApiResponse(response);
	}

	/**
	 */
	async exportSearch(requestParameters: ExportSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExportResponse> {
		const response = await this.exportSearchRaw(requestParameters, initOverrides);
		return await response.value();
	}
}

/**
 * @export
 * @enum {string}
 */
export enum ExportSearchXINFASEARCHLANGUAGE {
	Gremlin = 'gremlin',
	Elasticsearch = 'elasticsearch',
	KnowledgeGraphSearch = 'knowledge-graph-search',
}
